import { Flex, Select } from 'antd';
import React, { useContext, useRef, useState } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { COLOR_TAG_FILL, COLOR_TAG_SELECT, COLOR_TAG_TEXT_HOVER, TIMEOUT_LEAVE_SELECT_ANDOR } from '../const';
import useDispatchSetterStore from '../hooks/useDispatchSetterStore';
import useDynamicSelector from '../hooks/useDynamicSelector';
import { SmxPropsTableContext } from '../providers/propsTableProvider';
import { getSetterTable, ITableState } from '../store/slices/tableSlice';
import { GroupFilterType } from '../types';

interface ITableGroupFilterArr {
    group: GroupFilterType;
}

export const DivPlusStyled = styled(Flex).withConfig({
    shouldForwardProp: (prop) => prop !== 'isHoverSelect',
})<{ isHoverSelect?: boolean }>`
    background-color: ${({ isHoverSelect }) => (isHoverSelect ? COLOR_TAG_SELECT : COLOR_TAG_FILL)};
    border-radius: 0px;
    max-height: 35px;

    .ant-select .ant-select-selection-item {
        font-weight: bold;
        max-height: 30px;
        color: ${({ isHoverSelect }) => (isHoverSelect ? COLOR_TAG_TEXT_HOVER : 'inherit')};
    }
`;

const TableGroupFilterSelectAndOr: React.FC<ITableGroupFilterArr> = ({ group }) => {
    const { nameQuery, prefixStore } = useContext(SmxPropsTableContext);
    const setterTable = useDispatchSetterStore<ITableState>(getSetterTable(nameQuery + prefixStore));
    const listGroupFilters = useDynamicSelector('table', 'listGroupFilters');
    const [isHoverSelect, setIsHoverSelect] = useState<boolean>(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const onChangeAndOr = (e: any) => {
        setIsHoverSelect(false);
        setterTable({
            listGroupFilters: {
                ...listGroupFilters,
                [group.key]: {
                    ...listGroupFilters[group.key],
                    condition: e,
                },
            },
        });
    };

    return (
        <DivPlusStyled isHoverSelect={isHoverSelect}>
            <Select
                key={uuidv4()}
                options={[{ value: 'and' }, { value: 'or' }]}
                variant="borderless"
                suffixIcon={null}
                defaultValue={group.condition}
                value={group.condition}
                dropdownStyle={{ width: 65 }}
                onChange={onChangeAndOr}
                onMouseEnter={() => {
                    if (timeoutRef?.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    setIsHoverSelect(true);
                }}
                onMouseLeave={() => {
                    timeoutRef.current = setTimeout(() => {
                        setIsHoverSelect(false);
                    }, TIMEOUT_LEAVE_SELECT_ANDOR);
                }}
            />
        </DivPlusStyled>
    );
};

export default TableGroupFilterSelectAndOr;
